var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowB1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6155 2.99774C36.6155 1.34088 35.2724 -0.00226172 33.6155 -0.00226113L6.61554 -0.00226281C4.95869 -0.00226281 3.61554 1.34088 3.61554 2.99774C3.61554 4.65459 4.95869 5.99774 6.61554 5.99774H30.6155V29.9977C30.6155 31.6546 31.9587 32.9977 33.6155 32.9977C35.2724 32.9977 36.6155 31.6546 36.6155 29.9977L36.6155 2.99774ZM2.12109 34.4922L4.24241 36.6135L35.7369 5.11906L33.6155 2.99774L31.4942 0.876417L-0.000226557 32.3709L2.12109 34.4922Z",
    fill: "#313030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowB1);
export default __webpack_public_path__ + "static/media/Arrow_B1.dd5c616ff5484144dbc77428b325eabe.svg";
export { ForwardRef as ReactComponent };